import AccountOrganizationAPI from "../api/AccountOrganizationAPI";
import OrganizationAPI from "../api/OrganizationAPI";
export default {
  getAccountOrganizations() {
    return AccountOrganizationAPI.get();
  },
  getOrganizationPosts(id, page) {
    return new Promise((resolve, reject) => {
      OrganizationAPI.getPosts({
        params: {
          organization_id: id,
          organization_posts_per_page: 20,
          page: page || 1
        }
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }
};
